'use strict';

var _ = require('lodash');
var ConfigurationFoMarketsController = function ConfigurationFoMarketsController($scope, dataRetrieverService, configurationFoMarketsService, dataRetrieverConstantsService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_FO_MARKETS_MODE).setCustomSearchCriteriaRules([]);
  $scope.makeExportToCsv = function (data) {
    configurationFoMarketsService.exportToCsv(data);
  };
  $scope.customRemove = function (rowsToBeRemovedFromServer, gridData, rowIndicesToBeRemoved) {
    configurationFoMarketsService.remove(rowsToBeRemovedFromServer, gridData, rowIndicesToBeRemoved);
  };
  $scope.customSave = function (editedRows, gridData) {
    return configurationFoMarketsService.save(editedRows, gridData);
  };
  $scope.customSaveValidation = function (editedRows, gridData) {
    return configurationFoMarketsService.validate(editedRows, gridData);
  };
};
ConfigurationFoMarketsController.$inject = ['$scope', 'DataRetrieverService', 'ConfigurationFoMarketsService', 'DataRetrieverConstantsService'];
module.exports = ConfigurationFoMarketsController;